import ParallaxElement from './parallax_element';

export default ParallaxElement;
